import React from 'react';
import './ProductListButton.css';

const ProductListButton = ({
  label,
  icon,
  onClick,
  color = "#000000", // Always black border & text
  textColor = "#000000", // Always black text unless solid
  outline = true,
  disabled = false
}) => {
  const btnStyle = {
    backgroundColor: outline ? 'transparent' : color,
    color: outline ? color : textColor,
    border: `0.5px solid ${color}`,
    opacity: disabled ? 0.2 : 1,
    cursor: disabled ? 'not-allowed' : 'pointer'
  };

  return (
    <button
      className="productlist-modern-btn"
      onClick={onClick}
      style={btnStyle}
      disabled={disabled}
    >
      {icon && <i className={`${icon} btn-icon`} />} {label}
    </button>
  );
};

export default ProductListButton;
